import { System } from 'src/app/@framework/core/clms.fw.dotnet';
import * as Domain from '../Domain';
import * as Common from '../../@framework/common';
import { CLMS  } from 'src/app/@framework/core/clms.fw.common';
import { Joove } from 'src/app/@framework/core/Joove';
import * as moment from 'moment';
import { TranslateService } from '@ngx-translate/core';
import { DataListColumnInfo, DataListColumnItemType, ListDynamicColumnValue } from '@framework/components/DataList/helpers/List.helper.classes';
import { ValueFormat } from '@framework/core/clms.fw.angular';
var numeral = require('numeral');
const VerEx = require('verbal-expressions');


export class CheckbookGenerator  {
    _originalTypeClassName = "zERP.BO.CheckbookGenerator";
constructor(protected translateService: TranslateService = null) {
if (translateService != null) {
CheckbookGenerator.translate = translateService;
}
this.From = null;
this.To = null;
this.Length = null;
this.Separator = null;
this.Prefix = null;
this.Suffix = null;
this.UseCheckDigitForSuffix = false;
this.CheckDigitAlgorithm = null;
this.CheckbookGeneratorKey = null;
this._key = this.CheckbookGeneratorKey = 0; 
}

static translate: TranslateService;
_key: any;
From:any;
To:any;
Length:any;
Separator:any;
Prefix:any;
Suffix:any;
UseCheckDigitForSuffix:any;
CheckDigitAlgorithm:any;
private _CheckbookGeneratorKey:any;
get CheckbookGeneratorKey(): any {
    return this._CheckbookGeneratorKey;
  }
set CheckbookGeneratorKey(value: any) {
    this._CheckbookGeneratorKey = value;
    this._key = value;
  }

static GenerateCheckDigit(number: any,algorithm: any): any{switch (algorithm) {case Domain.CheckDigitAlgorithm.Piraeus1:
{
return Domain.CheckbookGenerator.GenerateCheckDigitPiraeus1(number);}
default:
{
throw Error(this.translate.instant('CheckBO_RES_CHECKDIGIT_ALGORITHM_NOT_FOUND'));}
}
}
static GenerateCheckDigitPiraeus1(number: any): any{if (CLMS.Framework.Number.NotEqual(() => number.length, () => 8)) {throw Error(CLMS.Framework.String.Format(this.translate.instant('CheckBO_RES_PIRAEUS_CHECK_DIGIT_INVALID_DIGITS'), number?.length));}
let sum = 0;
let factor = 2;
for (var i = 0; CLMS.Framework.Number.LessThan(() => i, () => number.length); i = Joove.Common.safeNumber(i) + Joove.Common.safeNumber(1)) {
let digit = number?.substr(Joove.Common.safeNumber(number?.length) - Joove.Common.safeNumber(i) - Joove.Common.safeNumber(1), 1);let digitInt = CLMS.Framework.Integer.Parse(digit);sum = Joove.Common.safeNumber(sum) + Joove.Common.safeNumber(digitInt) * Joove.Common.safeNumber(factor);factor = Joove.Common.safeNumber(factor) + Joove.Common.safeNumber(1);}

let mod11 = Joove.Common.safeNumber(sum) % Joove.Common.safeNumber(11);
if (CLMS.Framework.Number.Equal(() => mod11, () => 0)) {return "1";}else if (CLMS.Framework.Number.Equal(() => mod11, () => 1)) {return "0";}else {return (Joove.Common.safeNumber(11) - Joove.Common.safeNumber(mod11))?.toString();}
}
static Reset($this: any): any{$this.From = 1;
$this.To = 50;
$this.Separator = "-";
$this.Length = 2;
$this.Prefix = "";
$this.Suffix = "";
$this.UseCheckDigitForSuffix = false;
$this.CheckDigitAlgorithm = Domain.CheckDigitAlgorithm.None;
}

static IsNew($this: any): boolean {
                if ($this == null) return true;
                return $this.CheckbookGeneratorKey == null || $this.CheckbookGeneratorKey == 0;
            }


}